// extracted by mini-css-extract-plugin
export var pillWrapper = "_in-0";
export var showOverflow = "_in-1";